import { render, staticRenderFns } from "./MutilvideoUpload.vue?vue&type=template&id=ff7ec67c&scoped=true"
import script from "./MutilvideoUpload.vue?vue&type=script&lang=js"
export * from "./MutilvideoUpload.vue?vue&type=script&lang=js"
import style0 from "./MutilvideoUpload.vue?vue&type=style&index=0&id=ff7ec67c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7ec67c",
  null
  
)

export default component.exports